import React, { useState } from "react";
import { IconButton, Box, Typography } from "@mui/material";
import { Close as CloseIcon } from "@mui/icons-material";
import {
  formatChatTime,
  isAdminChatMessage,
  normalizeChatList,
  normalizeChatMessage,
  sortChatMessages,
} from "./chatMessageHelpers";

const isImage = (msg) => msg?.url && msg?.url.includes("UserPics");

const isAudio = (msg) => msg?.url && msg?.url.includes("UserAudio");

const isLocation = (msg) => msg?.url && msg?.url.includes("google.com/maps");

export default function ShowChatData(props) {
  const chatArray = sortChatMessages(
    normalizeChatList(props?.props?.chat || {}).map((msg) => normalizeChatMessage(msg)),
  );
  const [isModalOpen, setIsModalOpen] = useState(false);

  //console.log("props?.props?.chat", props?.props?.chat);

  const handleClick = () => setIsModalOpen(true);
  const handleClose = () => setIsModalOpen(false);

  return (
    <div>
      {chatArray.length > 0 && (
        <button onClick={handleClick} className="btn btn-danger btn-sm">
          Open Chat
        </button>
      )}

      {isModalOpen && (
        <div style={styles.modalOverlay}>
          <div style={styles.modal}>
            <div style={styles.modalHeader}>
              <IconButton onClick={handleClose} style={styles.closeButton}>
                <CloseIcon />
              </IconButton>
            </div>
            <div style={styles.modalContent}>
              <h4>Chat Messages</h4>
              <Box
                sx={{
                  flexGrow: 1,
                  overflowY: "auto",
                  padding: 1,
                  borderRadius: 3,
                }}
              >
                {chatArray.length === 0 ? (
                  <Typography variant="body2">No chat messages yet.</Typography>
                ) : (
                  chatArray.map((msg, index) => (
                    <Box
                      key={index}
                      sx={{
                        display: "flex",
                        flexDirection: isAdminChatMessage(msg) ? "row-reverse" : "row",
                        alignItems: "center",
                        marginBottom: 1,
                      }}
                    >
                      <Box
                        sx={{
                          maxWidth: "70%",
                          wordWrap: "break-word",
                          backgroundColor: isAdminChatMessage(msg) ? "#E6E6E6" : "#f8d7da",
                          borderRadius: 2,
                          padding: 1,
                          marginLeft: isAdminChatMessage(msg) ? 0 : 1,
                          marginRight: isAdminChatMessage(msg) ? 1 : 0,
                        }}
                      >
                        <Box>
                          {isImage(msg) && (
                            <a href={msg.url} target="_blank" rel="noopener noreferrer">
                              <img
                                src={msg.url}
                                alt="Chat Image"
                                style={{
                                  width: "100%",
                                  maxWidth: "220px",
                                  borderRadius: "8px",
                                  cursor: "pointer",
                                }}
                              />
                            </a>
                          )}

                          {isAudio(msg) && (
                            <audio controls style={{ width: "220px" }}>
                              <source src={msg.url} type="audio/mp4" />
                              Your browser does not support audio playback.
                            </audio>
                          )}

                          {isLocation(msg) && (
                            <a
                              href={msg.url}
                              target="_blank"
                              rel="noopener noreferrer"
                              style={{
                                color: "#0d6efd",
                                fontWeight: 500,
                                textDecoration: "underline",
                                wordBreak: "break-all",
                              }}
                            >
                              📍 View Location on Map
                            </a>
                          )}

                          {!msg.url && <Typography variant="body2">{msg.message}</Typography>}
                        </Box>

                        <Typography
                          variant="caption"
                          sx={{ textAlign: isAdminChatMessage(msg) ? "right" : "left", color: "gray" }}
                        >
                          {formatChatTime(msg.time)}
                        </Typography>
                      </Box>
                    </Box>
                  ))
                )}
              </Box>
            </div>
            <div style={styles.modalFooter}>
              <button onClick={handleClose} className="btn btn-dark btn-sm">
                Close
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

const styles = {
  modalOverlay: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 1000,
  },
  modal: {
    backgroundColor: "#fff",
    padding: "20px",
    borderRadius: "5px",
    width: "50%",
    position: "relative",
    overflowY: "auto",
    maxHeight: "80vh",
  },
  modalHeader: {
    display: "flex",
    justifyContent: "flex-end",
    marginBottom: "10px",
  },
  closeButton: {
    fontSize: "24px",
    color: "#333",
  },
  modalContent: {
    marginBottom: "20px",
  },
  modalFooter: {
    display: "flex",
    justifyContent: "center",
    marginTop: "20px",
  },
};
